export default "__VITE_ASSET__c5f8c82d__"